import { FunctionComponent } from 'react';
import { MdError } from 'react-icons/md';
import { cn } from '../../utilities/cn';

interface ErrorMessageProps {
  message: string;
  className?: string;
}

const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
  message,
  className,
}) => {
  return (
    <p className={cn('mb-1 flex items-center text-xs text-red-500', className)}>
      <MdError className="mr-1" />
      {message}
    </p>
  );
};

export default ErrorMessage;
